export default __webpack_public_path__ + "static/media/tile_itinerary.7903eb7e.jpg";